import { DbRead } from "../database";
import { ExistingSiteKeyUserPermissions } from "../models/site-key-user-permissions";
import { ExistingSiteKeyUserDoc } from "../models/site-key-users";

export async function getPermissionsMap(
  allUsersList: ExistingSiteKeyUserDoc[],
  siteKey: string,
): Promise<Record<string, ExistingSiteKeyUserPermissions>> {
  const permissionsMap: Record<string, ExistingSiteKeyUserPermissions> = {};
  // Create all promises at once, then execute them in parallel
  const readPromises = allUsersList.map(async (user) => {
    if (!user.id) return null;

    const permissionDoc = await DbRead.user.getSiteKeyPermissions(
      siteKey,
      user.id,
    );
    return { id: user.id, doc: permissionDoc };
  });
  const results = await Promise.all(readPromises);

  // Build the map from the results
  for (const result of results) {
    if (result && result.id) permissionsMap[result.id] = result.doc;
  }
  return permissionsMap;
}
